
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'
import ButtonOptional from '@/components/molecules/ButtonOptional.vue'

/**
 * インフォメーションパネルの生徒情報
 */
@Component({
  components: {
    ButtonBase,
    ImageBase,
    ButtonOptional,
  },
})
export default class InformationPanelStudent extends Vue {
  /** 生徒の画像URL */
  @Prop()
  private imageUrl!: string

  /** 生徒ID */
  @Prop()
  private studentId!: string

  /** 戻るボタン押下時のイベント */
  @Prop()
  private eventBackButton!: () => void

  /** 編集ボタン押下時のイベント */
  @Prop()
  private eventClickEditButton!: () => void

  /** ログアウトボタン押下時のイベント */
  @Prop()
  private eventClickLogoutButton!: () => void

  /** パスワード変更ボタン押下時のイベント */
  @Prop()
  private eventClickChangePasswordButton!: () => void

  /** メールアドレス変更ボタン押下時のイベント */
  @Prop()
  private eventClickChangeMailAddressButton!: () => void
}
